<template>
    <div class="home">

        <home-public v-if="$user.noLoggedInUser()"></home-public>

        <home-admin v-if="$user.roleIs('ADMIN')" ></home-admin>

        <home-reseller-admin v-if="$user.roleIs('RESELLER_ADMIN')" :reseller-id="$store.state.currentUser.reseller.id"></home-reseller-admin>

        <company-view :company-id="$user.adminCompany().id"
                      v-if="$user.roleIs('COMPANY_ADMIN') || $user.roleIs('MULTI_COMPANY_ADMIN')"></company-view>

        <home-participant v-if="$user.roleIs('PARTICIPANT')"></home-participant>

        <patient-admin v-if="$user.roleIs('PRACTITIONER')"></patient-admin>

    </div>

</template>

<script>

import Vue from 'vue'
import HomeAdmin from '@/pages/HomeAdmin'
import HomeResellerAdmin from '@/pages/HomeResellerAdmin'
import CompanyView from '@/pages/CompanyView'
import HomePublic from '@/pages/HomePublic'
import HomeParticipant from '@/pages/HomeParticipant'
import PatientAdmin from '@/pages/PatientAdmin'

/**
 * Home page - displays different components depending on user role
 */
export default Vue.extend({
    name: "Home",
    components: {
        HomeAdmin,
        HomeResellerAdmin,
        CompanyView,
        HomePublic,
        HomeParticipant,
        PatientAdmin,
    },
    data() {
        return {
            versionUpdatesShown: false
        }
    },
    updated() {

        if (!this.$user.noLoggedInUser() && !this.versionUpdatesShown) {
            const currentUpdates = this.$i18n.gt('VERSION_UPDATES')
            const lastUpdates = localStorage.getItem('lastVersionUpdates')
            if (lastUpdates != currentUpdates) {
                const updateNotes = this.$createElement(
                    'div',
                    {
                        domProps: {
                            innerHTML:
                                "<div class='container'>" +
                                currentUpdates +
                                (this.$user.practitionerId() ? this.$i18n.gt('PRACTITIONER_TUTORIAL_LINK') : '') +
                                "</div>"
                        }
                    }
                )

                this.$bvModal.msgBoxOk([updateNotes])
                localStorage.setItem('lastVersionUpdates', currentUpdates)
                this.versionUpdatesShown = true
            }
        }
    }
})
</script>

<style lang="scss">

</style>
